import { CrudPage } from '@restavo/crud';
import React from 'react';
import { useInventoryItemsPage } from 'src/features/inventoryItems';

const InventoryItems = React.memo(() => {
  const { page, movementsModal } = useInventoryItemsPage();
  return (
    <>
      <CrudPage {...page} />
      {movementsModal}
    </>
  );
});

export default InventoryItems;
